<template>
  <section class="content">
    <slot></slot>
  </section>
</template>

<script>
export default {
  name: 'Content'
}
</script>

<style lang="scss">
.content{
  color: var(--color-content-text);
  padding: 0 24px 40px 24px;

  @media (min-width: $S) {
      padding: 0 30px 50px 30px;
  }

  a{
    font-family: Averia;    
  }
  a:not(:hover){
    color: var(--color-content-links);
  }

  &.narrow{
    max-width: 500px;
    margin: 0 auto;
  }

  h1, 
  h2,
  h3{
    font-family: Averia, Cambria, 'Times New Roman', serif;    
  }

  h1,h2 {      
    margin-top: 60px;
    margin-bottom: 40px;
    text-align: center;
  }

  h1,h2,h3 {
    &.background {
      position: relative;
      z-index: 1;
      
      &:before {
          border-top: 1px dotted #a0a0a0;
          content:"";
          margin: 0 auto; /* this centers the line to the full width specified */
          position: absolute; /* positioning must be absolute here, and relative positioning must be applied to the parent */
          top: 50%; left: 0; right: 0; bottom: 0;
          width: 100%;
          z-index: -1;
      }

      span { 
          /* to hide the lines from behind the text, you have to set the background color the same as the container */ 
          background: #fff; 
          padding: 0 15px; 
      }
    }
  }

  h1{
    font-size: 36px;
  }

  h2{
    font-size: 28px;
  }  

  h3{
    font-size: 20px;
    line-height: 24px;
  }

  p {
    max-width: 700px;
    line-height: 24px;
    font-size: 18px;
    text-align: justify;
    margin: 0 auto;
    letter-spacing: -1px;  // TODO consider -1 or -0.5

    @media (max-width: 360px) {
        font-size: 16px;
    }

    @media (min-width: 480px) {
        letter-spacing: normal;
    }
  }

  section{
    max-width: 700px;
    margin: 0 auto;

    p {
      line-height: 22px;
      font-size: 16px;
    }
  }
}
</style>
